import * as React from 'react';
import cn from 'classnames';
import { EngineTheme, useTheme } from '../../../../../theme';

type ClassNames = EngineTheme['CheckinCardItem']['CheckinCardItem'];

export interface CheckinCardItemProps {
	className?: string;
	classes?: Partial<ClassNames>;
	children: React.ReactNode;
	delimiter?: 'line' | 'dashed';
	delimiterText?: string;
	delimiterGap?: boolean;
	spacingBottom?: string;
	padding?: string;
}

const CheckinCardItem: React.FC<CheckinCardItemProps> = ({
	className,
	children,
	delimiter,
	delimiterText,
	delimiterGap,
	spacingBottom,
	padding,
	classes
}) => {
	const { CheckinCardItem: theme } = useTheme('CheckinCardItem');

	const [calculatedFontSize, setCalculatedFontSize] = React.useState<number | null>(null);
	const delimiterTextRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		if (delimiterTextRef.current) {
			const textHeight = delimiterTextRef.current.offsetHeight;
			const halfTextHeight = Math.ceil(textHeight / 2);

			setCalculatedFontSize(halfTextHeight);
		}
	}, [delimiterText]);

	return (
		<div className={cn(theme.container, className)} style={{ padding, marginBottom: spacingBottom }}>
			<div className={cn(theme.content, classes?.content)}>{children}</div>

			{delimiter && (
				<div
					className={cn(theme.delimiter, theme[delimiter], {
						[theme.delimiterGap]: delimiterText || delimiterGap
					})}
					style={
						calculatedFontSize
							? {
									marginTop: `${calculatedFontSize}px`,
									marginBottom: `${calculatedFontSize}px`
							  }
							: undefined
					}
				>
					{delimiterText && (
						<div ref={delimiterTextRef} className={cn(theme.delimiterText, classes?.delimiterText)}>
							{delimiterText}
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default CheckinCardItem;
